import { IconsProps } from '@/types/shared'

const SearchIcons: React.FC<IconsProps> = (props) => {
    return (
        <div {...props}>
            <svg
                viewBox="0 0 17 17"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M12.0494 10.6745H11.2876L11.0176 10.4141C11.9626 9.31482 12.5316 7.88768 12.5316 6.33518C12.5316 2.87339 9.72549 0.0673218 6.26371 0.0673218C2.80192 0.0673218 -0.00415039 2.87339 -0.00415039 6.33518C-0.00415039 9.79696 2.80192 12.603 6.26371 12.603C7.81621 12.603 9.24335 12.0341 10.3426 11.0891L10.603 11.3591V12.1209L15.4244 16.9327L16.8612 15.4959L12.0494 10.6745ZM6.26371 10.6745C3.86264 10.6745 1.92442 8.73625 1.92442 6.33518C1.92442 3.93411 3.86264 1.99589 6.26371 1.99589C8.66478 1.99589 10.603 3.93411 10.603 6.33518C10.603 8.73625 8.66478 10.6745 6.26371 10.6745Z"
                    fill="currentColor"
                />
            </svg>
        </div>
    )
}

export default SearchIcons
